'use client'

import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'
import { useMyCIOLanguageOrCookie } from '@/lib/mycio/MyCIOLanguageContext'
import { getMyCIOShellChromeCopy } from '@/lib/mycio/copy/shellChrome'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  // Replaces the whole document, provider included: the language comes from the cookie.
  const language = useMyCIOLanguageOrCookie()
  const t = getMyCIOShellChromeCopy(language).globalError
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html lang={language} dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <body>
        <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
          <h2>{t.title}</h2>
          <button onClick={() => reset()}>{t.tryAgain}</button>
        </div>
      </body>
    </html>
  )
}
